import { Modal, Backdrop, Fade, Box } from "@mui/material";
import React from "react";
import "./modalwrap.scss";

function ModalWrap({ open, onClose, children }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 200,
        },
      }}
      className="modal-wrapper"
    >
      <Fade in={open}>
        <Box className="modal-box">{children}</Box>
      </Fade>
    </Modal>
  );
}

export default ModalWrap;
